module.exports = __webpack_public_path__ + "d9d7f8f1.svg";